// extracted by mini-css-extract-plugin
module.exports = {"headingLine":"DynamicHeadingLine_headingLine__2Pqwh","marginSmall":"DynamicHeadingLine_marginSmall__3iu9i"};